<template>
    <div>
      <base-header style="background: rgba(79, 47, 129, 1);
background: radial-gradient(circle, rgba(79, 47, 129, 1) 25%, rgba(79, 47, 129, 0.73) 100%);" class="pb-6 pb-8 pt-5 pt-md-5">
            <!-- Card stats -->
            <!-- <div class="row">
              <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-header bg-transparent">
                            <h3 class="mb-0">Icons</h3>
                        </div>
                        <div class="card-body">
                            <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->

                <!-- <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total traffic"
                                type="gradient-red"
                                sub-title="350,897"
                                icon="ni ni-active-40"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 3.48%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total traffic"
                                type="gradient-orange"
                                sub-title="2,356"
                                icon="ni ni-chart-pie-35"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 12.18%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Sales"
                                type="gradient-green"
                                sub-title="924"
                                icon="ni ni-money-coins"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-danger mr-2"><i class="fa fa-arrow-down"></i> 5.72%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>

                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Performance"
                                type="gradient-info"
                                sub-title="49,65%"
                                icon="ni ni-chart-bar-32"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 54.8%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div> -->
            <!-- </div> -->
        </base-header>

        <modal :show.sync="modals.modalchangepass" dir="ltr">
        <template slot="header">
           <span style="font-size: 24px; color: black;" id="exampleModalLabel">{{texts.change_password}}</span>
        </template>
          <div>
            <div class="row">
              <div class="col-md-2">
                </div>
              <div v-if="language=='ltr'" class="col-md-8" style="text-align : right;">
                <center>
                <base-input v-if="language=='ltr'" alternative placeholder="Old Password" style="text-align : center;" v-model="old_password" ></base-input>

                <base-input v-if="language=='ltr'" alternative placeholder="New Password" style="text-align : center;" v-model="new_password" ></base-input>

                <base-input v-if="language == 'ltr'" alternative placeholder="Confirm New Password" style="text-align : center;" v-model="confirm_new_password" ></base-input>

                </center>
              </div>
              <div v-else class="col-md-8 text-right" >
                <center>

                <base-input dir="rtl" alternative placeholder="كلمة المرور القديمة" style="text-align : right;" v-model="old_password" ></base-input>

                <base-input dir="rtl" alternative placeholder="كلمة المرور الجديدة" style="text-align : right;" v-model="new_password" ></base-input>

                <base-input dir="rtl" alternative placeholder="تأكيد كلمة المرور الجديدة" style="text-align : right;" v-model="confirm_new_password"></base-input>
                </center>
              </div>
            </div>
          </div>
        <template slot="footer" style="justify-content:centered;">
            <base-button type="secondary" @click="modals.modalchangepass = false" style="margin-left:50px;">{{texts.close}}</base-button>
            <base-button type="primary" @click="updatePass()" style="margin-left:50px;">{{texts.change_password}}</base-button>
        </template>
        </modal>

        <modal :show.sync="modals.modal9" dir="ltr">
        <template slot="header">
           <span style="font-size: 24px; color: black;" id="exampleModalLabel">{{texts.update_phone}}</span>
        </template>
          <div>
            <div class="row">
              <div class="col-md-2" style="margin-right:-20px;margin-left:20px;">

                  <vue-country-code style="height:43px;margin-top:1px;"
                       @onSelect="onSelect"
                       :preferredCountries="['sa', 'ae', 'bh', 'jo']">
                  </vue-country-code>

                </div>
              <div class="col-md-8" style="text-align : center;">
                <center>
                <base-input alternative placeholder="Phone" style="text-align : center;" v-model="phone_number" ></base-input>
                </center>
              </div>
            </div>
          </div>
        <template slot="footer" style="justify-content:centered;">
            <base-button type="secondary" @click="modals.modal9 = false" style="margin-left:50px;">{{texts.close}}</base-button>
            <base-button type="primary" @click="updatePhone()" style="margin-left:50px;">{{texts.update_phone}}</base-button>
        </template>
        </modal>

        <modal :show.sync="modals.modalotp" dir="ltr">
        <template slot="header">
           <span style="font-size: 24px; color: black;" id="exampleModalLabel">{{texts.confirm_update_phone}}</span>
        </template>
          <div>
            <center>
            <h3 v-if="language == 'ltr'">You will receive a confirmation code by Email</h3>
            <h3 v-else>سوف تتلقى رمز التأكيد عن طريق البريد الإلكتروني</h3>
            </center>
            <div class="row">
              <div class="col-md-2">
                </div>
              <div class="col-md-8" style="text-align : center;">
                <center>
                <base-input alternative placeholder="OTP" style="text-align : center;" v-model="otp" ></base-input>
                </center>
              </div>
            </div>
          </div>
        <template slot="footer" style="justify-content:centered;">
            <base-button type="secondary" @click="modals.modalotp = false" style="margin-left:50px;">{{texts.close}}</base-button>
            <base-button type="primary" @click="otpPhone();" style="margin-left:50px;">{{texts.confirm_update_phone}}</base-button>
        </template>
        </modal>

        <modal :show.sync="modals.modalotpchangepass" dir="ltr">
        <template slot="header">
           <span style="font-size: 24px; color: black;" id="exampleModalLabel">{{texts.confirm_password_change}}</span>
        </template>
          <div>
            <center>
            <h3 v-if="language == 'ltr'">You will receive a confirmation code by Email</h3>
            <h3 v-else>سوف تتلقى رمز التأكيد عن طريق البريد الإلكتروني</h3>
            </center>
            <div class="row">
              <div class="col-md-2">
                </div>
              <div class="col-md-8" style="text-align : center;">
                <center>
                <base-input alternative placeholder="OTP" style="text-align : center;" v-model="otp" ></base-input>
                </center>
              </div>
            </div>
          </div>
        <template slot="footer" style="justify-content:centered;">
            <base-button type="secondary" @click="modals.modalotpchangepass = false" style="margin-left:50px;">{{texts.close}}</base-button>
            <base-button type="primary" @click="otpPass();" style="margin-left:50px;">{{texts.confirm_password_change}}</base-button>
        </template>
        </modal>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-header bg-transparent" v-if="language=='ltr'">
                            <h2>{{texts.settings}}</h2>
                        </div>
                        <div class="card-header bg-transparent text-right" v-else>
                            <h2>{{texts.settings}}</h2>
                        </div>
                        <div class="card-body">
                           <form v-on:submit.prevent="onSubmit(title, message, );">
                            <fieldset class="form-group" v-if="!isTeam">
                            <div class="row">
                              <div class="col-md-5" v-if="language == 'ltr'">
                                <h3>Title</h3>

                                <base-input alternative placeholder="Title" v-model="title" ></base-input>
                              </div>
                              <div v-else class="col-md-5 text-right">
                                <h3>{{texts.title}}</h3>

                                <base-input alternative placeholder="Title" v-model="title" ></base-input>
                              </div>
                            </div>
                          </fieldset>

                          <fieldset class="form-group">
                          <div class="row">
                            <div class="col-md-5" v-if="language == 'ltr'">
                              <h3>Name</h3>

                              <base-input alternative placeholder="Name" v-model="name" ></base-input>
                            </div>
                            <div v-else class="col-md-5 text-right">
                              <h3>اسم</h3>

                              <base-input alternative placeholder="اسم" v-model="name" ></base-input>
                            </div>
                          </div>
                        </fieldset>

                        <fieldset class="form-group">
                        <div class="row">
                          <div class="col-md-5" v-if="language == 'ltr'">
                            <h3>Email</h3>

                            <base-input alternative placeholder="Email" v-model="email" ></base-input>
                          </div>
                          <div v-else class="col-md-5 text-right">
                            <h3>البريد الإلكتروني</h3>

                            <base-input alternative placeholder="البريد الإلكتروني" v-model="email" ></base-input>
                          </div>
                        </div>
                      </fieldset>

                      <fieldset class="form-group" v-if="!isTeam">
                      <div class="row">
                        <div class="col-md-5" v-if="language == 'ltr'">
                          <h3>Notifications</h3>

                          <base-checkbox v-model="public_chat_message" >{{texts.public_chat_message}}</base-checkbox>
                          <base-checkbox v-model="meeting_is_set" >{{texts.meeting_is_set}}</base-checkbox>
                          <base-checkbox v-model="mom_is_available" >{{texts.mom_is_available}}</base-checkbox>
                          <base-checkbox v-model="report_uploaded" >{{texts.report_uploaded}}</base-checkbox>
                          <base-checkbox v-model="other_cmembers_inquiries" >{{texts.other_cmembers_inquiries}}</base-checkbox>
                        </div>
                        <div v-else class="col-md-5 text-right" dir="rtl">
                          <h3>إشعارات</h3>
                          <base-checkbox v-model="public_chat_message" dir="rtl">{{texts.public_chat_message}}</base-checkbox>
                          <base-checkbox v-model="meeting_is_set" >{{texts.meeting_is_set}}</base-checkbox>
                          <base-checkbox v-model="mom_is_available" >{{texts.mom_is_available}}</base-checkbox>
                          <base-checkbox v-model="report_uploaded" >{{texts.report_uploaded}}</base-checkbox>
                          <base-checkbox v-model="other_cmembers_inquiries" >{{texts.other_cmembers_inquiries}}</base-checkbox>
                        </div>
                      </div>
                    </fieldset>

                      <fieldset class="form-group">
                      <div class="row">
                        <div class="col-md-8" v-if="language == 'ltr'">
                           <base-button type="primary" v-on:click="updateData">Update Data</base-button>
                        </div>
                        <div class="col-md-8 text-right" v-else >

                           <base-button type="primary" v-on:click="updateData">تحديث البيانات</base-button>
                        </div>
                      </div>
                    </fieldset>

                        <fieldset class="form-group">
                        <div class="row">
                          <div class="col-md-5" v-if="language == 'ltr'">
                            <h3>Phone Number</h3>

                            <base-button type="success" v-on:click="changePhoneNumber()">Change Phone Number</base-button>
                          </div>
                          <div v-else class="col-md-5 text-right">
                            <h3>رقم الهاتف</h3>

                            <base-button type="success" v-on:click="changePhoneNumber()">تغيير رقم الهاتف</base-button>
                          </div>
                        </div>
                      </fieldset>

                      <fieldset class="form-group" >
                      <div class="row" >
                        <div class="col-md-5" v-if="language == 'ltr'">
                          <h3>Password</h3>
                          <base-button type="success" v-on:click="changePassword()">Change Password</base-button>
                        </div>
                        <div v-else class="col-md-5 text-right">
                          <h3>كلمه السر</h3>
                          <base-button type="success" v-on:click="changePassword()">تغيير كلمة المرور</base-button>
                        </div>
                      </div>
                    </fieldset>



                          </form>
<!--                                 <div class="col-lg-3 col-md-6"
                                     v-for="(icon, index) in icons" :key="icon.name + index">
                                    <button type="button"
                                            v-b-tooltip.hover.top
                                            :title="icon.name"
                                            v-clipboard:copy="icon.name"
                                            v-clipboard:success="onCopy"
                                            class="btn-icon-clipboard" data-clipboard-text="air-baloon">
                                        <div>
                                            <i :class="icon.name"></i>
                                            <span>{{icon.name.substring(6)}}</span>
                                        </div>
                                    </button>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>


</template>
<script>
  import { mapState } from "vuex";
import { GET_DELIVERABLES,CREATE_CHAT, GET_CHATS, SEND_MESSAGE, GET_PROFILE, UPDATE_PROFILE, CONFIRM_UPDATE_PHONE_NUMBER, UPDATE_PHONE_NUMBER, CHANGE_PASSWORD, CONFIRM_CHANGE_PASSWORD } from "@/store/actions.type";
import store from "@/store";
import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'
import BTooltipDirective from 'bootstrap-vue/es/directives/tooltip'
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import PDFObject from 'pdfobject';
import FullCalendar from '@fullcalendar/vue'
import PieChart from '@/components/Charts/PieChart';
import dayGridPlugin from '@fullcalendar/daygrid'
import CloseIcon from 'vue-beautiful-chat/src/assets/close-icon.png'
import OpenIcon from 'vue-beautiful-chat/src/assets/logo-no-bg.svg'
import FileIcon from 'vue-beautiful-chat/src/assets/file.svg'
import CloseIconSvg from 'vue-beautiful-chat/src/assets/close.svg'
import { mapGetters } from "vuex";
import UserService from "@/common/user.service";
import JwtService from "@/common/jwt.service";
import VueCountryCode from "vue-country-code";
  Vue.use(VueClipboard)
  export default {
    directives: {
      'b-tooltip': BTooltipDirective
    },
    components: {flatPicker, VueCountryCode},
    data() {
      return {
        texts : {
          back : UserService.getLanguage() === "rtl" ? "رجوع" : "Back",
          deliverables : UserService.getLanguage() === "rtl" ? "المخرجات" : "Deliverables",
          view : UserService.getLanguage() === "rtl" ? "عرض" : "View",
          findings : UserService.getLanguage() === "rtl" ? "الملاحظات" : "Findings",
          register : UserService.getLanguage() === "rtl" ? "تسجيل" : "Register",
          phonenumber : UserService.getLanguage() === "rtl" ? "رقم الهاتف" : "Phone Number",
          title : UserService.getLanguage() === "rtl" ? "المسمى الوظيفي" : "Title",
          newpass : UserService.getLanguage() === "rtl" ? "كلمة السر الجديدة" : "New Password",
          close : UserService.getLanguage() === "rtl" ? "إغلاق" : "Close",
          chats : UserService.getLanguage() === "rtl" ? ".  محادثات" : "Chats",
          view : UserService.getLanguage() === "rtl" ? "عرض" : "View",
          publicchat : UserService.getLanguage() === "rtl" ? "محادثة عامة" : "Public Chat",
          privatechat : UserService.getLanguage() === "rtl" ? "محادثة خاصة" : "Private Chat",
          settings : UserService.getLanguage() === "rtl" ? "الإعدادات" : "Settings",
          update_phone : UserService.getLanguage() === "rtl" ? "تحديث رقم الهاتف" : "Update Phone Number",
          confirm_update_phone : UserService.getLanguage() === "rtl" ? "تأكيد تحديث الهاتف" : "Confirm Phone Update",
          change_password : UserService.getLanguage() === "rtl" ? "تغيير كلمة المرور" : "Change Password",
          confirm_password_change : UserService.getLanguage() === "rtl" ? "تأكيد تغيير كلمة المرور" : "Confirm Password Change",
          public_chat_message : UserService.getLanguage() === "rtl" ? "رسائل الدردشة العامة" : "Public Chat Messages",
          meeting_is_set : UserService.getLanguage() === "rtl" ? "اجتماعات جديدة" : "New Meetings",
          mom_is_available : UserService.getLanguage() === "rtl" ? "توافر محضر الاجتماع" : "Meeting Minutes Availablity",
          report_uploaded : UserService.getLanguage() === "rtl" ? "تقرير تم تحميله" : "Uploaded Report",
          other_cmembers_inquiries : UserService.getLanguage() === "rtl" ? "استفسارات ممثلي العملاء الآخرين" : "Other Client Representatives Inquiries",
        },
        otp : '',
        public_chat_message : true,
        intital_public_chat_message : true,
        meeting_is_set : true,
        intital_meeting_is_set : true,
        mom_is_available : true,
        intital_mom_is_available : true,
        report_uploaded : true,
        intital_report_uploaded : true,
        other_cmembers_inquiries : true,
        intital_other_cmembers_inquiries : true,
        language : UserService.getLanguage() || "ltr",
        isTeam : JwtService.getUserType() === "team",
        title : "",
        initial_title : "",
        initial_phone_number : "",
        phone_number : "",
        initial_email : "",
        email : "",
        name : "",
        initial_name : "",
        old_password : "",
        new_password : "",
        confirm_new_password : "",
        modals : {
          modal9 : false,
          modalotp : false,
          modalchangepass : false,
          modalotpchangepass : false
        },
        country_code : ""

      }
    },
    mounted() {
      if (sessionStorage.getItem('reloaded') != null) {
      console.log('page was reloaded');
  } else {
    this.$router.push({ name: "login" })
      console.log('page was not reloaded');
  }
      Promise.all([
        store.dispatch(GET_PROFILE)
      ]).then((data) => {
        console.log(data[0]['data']);
          if (data[0]['data']) {
              this.title = data[0]['data']['title'];
              this.initial_title = data[0]['data']['title'];
              this.phone_number = data[0]['data']['phone_number'];
              this.name = data[0]['data']['name'];
              this.initial_name = data[0]['data']['name'];
              this.email = data[0]['data']['email'];
              this.initial_email = data[0]['data']['email'];
              // if (data[0]['data']['public_chat_message']) {
                this.public_chat_message = data[0]['data']['public_chat_message'];
                this.initial_public_chat_message = data[0]['data']['public_chat_message'];
                this.meeting_is_set = data[0]['data']['meeting_is_set'];
                this.initial_meeting_is_set = data[0]['data']['meeting_is_set'];
                this.mom_is_available = data[0]['data']['mom_is_available'];
                this.initial_mom_is_available = data[0]['data']['mom_is_available'];
                this.report_uploaded = data[0]['data']['report_uploaded'];
                this.initial_report_uploaded = data[0]['data']['report_uploaded'];
                this.other_cmembers_inquiries = data[0]['data']['other_cmembers_inquiries'];
                this.initial_other_cmembers_inquiries = data[0]['data']['other_cmembers_inquiries'];
              // }
              console.log(this.name);
          }
      });
    },
//     created() {
//   window.addEventListener('beforeunload', this.beforeWindowUnload)
// },
//
// beforeDestroy() {
//   window.removeEventListener('beforeunload', this.beforeWindowUnload)
// },
    methods: {
      confirmStayInDirtyForm() {
        return true && !this.confirmLeave()
      },

      beforeWindowUnload(e) {
        this.$router.push({ name: "login" })
        e.preventDefault();
        e.returnValue = '';
        // if (this.confirmStayInDirtyForm()) {
        //   // Cancel the event
        //   e.preventDefault()
        //   // Chrome requires returnValue to be set
        //   e.returnValue = ''
        // }
      },
      preventNav(event) {
        // if (!this.isEditing) return
        if (this.confirmStayInDirtyForm()) {
          event.preventDefault()
          event.returnValue = ""
        }
      },
      handler(event) {
        alert(event);
        event.preventDefault();
         console.log("CLOSING");
         console.log(event);
      },
      onSelect({name, iso2, dialCode}) {
       console.log(name, iso2, dialCode);
       this.country_code = dialCode;
     },
      getProfileData() {
        Promise.all([
          store.dispatch(GET_PROFILE)
        ]).then((data) => {
          console.log(data[0]['data']);
            if (data[0]['data']) {
                this.title = data[0]['data']['title'];
                this.initial_title = data[0]['data']['title'];
                this.phone_number = data[0]['data']['phone_number'];
                this.name = data[0]['data']['name'];
                this.initial_name = data[0]['data']['name'];
                this.email = data[0]['data']['email'];
                this.initial_email = data[0]['data']['email'];
                // if (data[0]['data']['public_chat_message'] !== undefined) {
                  this.public_chat_message = data[0]['data']['public_chat_message'];
                  this.initial_public_chat_message = data[0]['data']['public_chat_message'];
                  this.meeting_is_set = data[0]['data']['meeting_is_set'];
                  this.initial_meeting_is_set = data[0]['data']['meeting_is_set'];
                  this.mom_is_available = data[0]['data']['mom_is_available'];
                  this.initial_mom_is_available = data[0]['data']['mom_is_available'];
                  this.report_uploaded = data[0]['data']['report_uploaded'];
                  this.initial_report_uploaded = data[0]['data']['report_uploaded'];
                  this.other_cmembers_inquiries = data[0]['data']['other_cmembers_inquiries'];
                  this.initial_other_cmembers_inquiries = data[0]['data']['other_cmembers_inquiries'];
                // }
                console.log(this.name);
            }
        });
      },
      updateData() {
          let titleChanged = this.title !== this.initial_title;
          let nameChanged = this.name !== this.initial_name;
          let emailChanged = this.email !== this.initial_email;

          let publicChatChanged = this.public_chat_message !== this.initial_public_chat_message;
          let meetingSetChanged = this.meeting_is_set !== this.initial_meeting_is_set;
          let momIsAvailable = this.mom_is_available !== this.initial_mom_is_available;
          let reportUploaded = this.report_uploaded !== this.initial_report_uploaded;
          let otherCMembersInquiries = this.other_cmembers_inquiries !== this.initial_other_cmembers_inquiries;

          if (titleChanged || nameChanged || emailChanged || publicChatChanged || meetingSetChanged || momIsAvailable || reportUploaded || otherCMembersInquiries) {


            let formData = {'title':this.title, 'name' : this.name, 'email' : this.email, 'public_chat_message' : this.public_chat_message, 'meeting_is_set' : this.meeting_is_set, 'mom_is_available' : this.mom_is_available, 'report_uploaded' : this.report_uploaded, 'other_cmembers_inquiries' : this.other_cmembers_inquiries};
            console.log(formData);
            Promise.all([
              store.dispatch(UPDATE_PROFILE, formData),

            ]).then((data) => {
                if (Number(data[0]['errFlag']) === 0) {
                  this.getProfileData();
                    if (this.language === "ltr") {
                      this.$notify({
                        "title" : "Data successfully updated",
                        "type" : "success"
                      });
                    }
                    else {
                      this.$notify({
                        "title" : "تم تحديث البيانات بنجاح",
                        "type" : "success"
                      });
                    }
                }
            });
          }
      },
      updatePhone() {
        if (this.phone_number !== this.initial_phone_number) {
          if (this.phone_number.startsWith("0")) {
            this.phone_number = String(this.phone_number).substring(1, this.phone_number.length);
          }
          let formData = {'phone_number':"+" + this.country_code + String(this.phone_number)};
          console.log(formData);
          Promise.all([
            store.dispatch(UPDATE_PHONE_NUMBER, formData),

          ]).then((data) => {
              if (Number(data[0]['errFlag']) === 0) {
                  this.modals.modal9= false;
                  this.modals.modalotp = true;
              }
          });
        }
      },
      otpPhone() {
        if (this.otp !== "") {
          if (this.phone_number.startsWith("0")) {
            this.phone_number = String(this.phone_number).substring(1, this.phone_number.length);
          }
          let formData = {'phone_number':"+" + this.country_code + String(this.phone_number), 'otp' : this.otp};
          console.log(formData);
          Promise.all([
            store.dispatch(CONFIRM_UPDATE_PHONE_NUMBER, formData),

          ]).then((data) => {
              if (Number(data[0]['errFlag']) === 0) {
                this.getProfileData();
                this.otp = "";
                  this.modals.modal9= false;
                  this.modals.modalotp = false;
                  if (this.language === "ltr") {
                    this.$notify({
                      "title" : "Phone Number successfully updated !",
                      "type" : "success"
                    });
                  }
                  else {
                    this.$notify({
                      "title" : "تم تحديث رقم الهاتف بنجاح!",
                      "type" : "success"
                    });
                  }
              }
          });
        }
      },
      otpPass() {
        if (this.otp !== "") {
          let formData = { 'otp' : this.otp};
          console.log(formData);
          Promise.all([
            store.dispatch(CONFIRM_CHANGE_PASSWORD, formData),

          ]).then((data) => {
              if (Number(data[0]['errFlag']) === 0) {
                this.getProfileData();
                this.otp = "";
                  this.modals.modalotpchangepass= false;

                  if (this.language === "ltr") {
                    this.$notify({
                      "title" : "Password successfully updated !",
                      "type" : "success"
                    });
                  }
                  else {
                    this.$notify({
                      "title" :"تم تحديث كلمة المرور بنجاح",
                      "type" : "success"
                    });
                  }
              }
              else {
                if (this.language === "ltr") {
                  this.$notify({
                    "title" : "Wrong code entered",
                    "type" : "warning"
                  });
                }
                else {
                  this.$notify({
                    "title" : "رمز خاطئ",
                    "type" : "warning"
                  });
                }
              }
          });
        }
      },
      updatePass() {
        if (this.old_password !== "" && this.new_password !== "" && this.confirm_new_password !== "") {
          if (this.new_password !== this.confirm_new_password) {
            if (String(this.language) === "ltr") {
              this.$notify({
                    type: 'warning',
                    title: 'Passwords must match'
                  })
            }
            else {
              this.$notify({
                    type: 'warning',
                    title: 'الكلمة السريه يجب ان تتطابق'
                  })
            }
          }
          else {
            let formData = {'old_password' : this.old_password, 'new_password' : this.new_password, 'confirm_new_password' : this.confirm_new_password};
            Promise.all([
              store.dispatch(CHANGE_PASSWORD, formData),

            ]).then((data) => {
                if (Number(data[0]['errFlag']) === 0) {
                    this.modals.modalchangepass= false;
                    this.modals.modalotpchangepass = true;
                }
                else {
                  if (data[0]['errNum']) {
                    if (Number(data[0]['errNum']) === 2) {
                      if (String(this.language) === "ltr") {
                        this.$notify({
                              type: 'warning',
                              title: 'Incorrect old password'
                            })
                      }
                      else {
                        this.$notify({
                              type: 'warning',
                              title: 'كلمة السر القديمة غير صحيحة'
                            })
                      }
                    }
                  }
                }
            });
          }
        }
        else {
          if (String(this.language) === "ltr") {
            this.$notify({
                  type: 'warning',
                  title: 'Please fill in all required fields'
                })
          }
          else {
            this.$notify({
                  type: 'warning',
                  title: 'يرجى تعبئة جميع الحقول المطلوبة'
                })
          }
        }
      },
      otpPass() {
        if (this.otp !== "") {
          let formData = {'phone_number':this.phone_number, 'otp' : this.otp};
          console.log(formData);
          Promise.all([
            store.dispatch(CONFIRM_CHANGE_PASSWORD, formData),

          ]).then((data) => {
              if (Number(data[0]['errFlag']) === 0) {
                  this.otp = "";
                  this.old_password = "";
                  this.new_password = "";
                  this.confirm_new_password = "";
                  this.modals.modalotpchangepass = false;
                  if (this.language === "ltr") {
                    this.$notify({
                      "title" : "Password successfully changed",
                      "type" : "success"
                    });
                  }
                  else {
                    this.$notify({
                      "title" : "تم تغيير كلمة المرور بنجاح",
                      "type" : "success"
                    });
                  }
              }
              else {
                if (this.language === "ltr") {
                  this.$notify({
                    "title" : "Wrong code entered",
                    "type" : "warning"
                  });
                }
                else {
                  this.$notify({
                    "title" : "رمز خاطئ",
                    "type" : "warning"
                  });
                }
              }
          });
        }
      },
      changePhoneNumber() {
        this.modals.modal9 = true;
      },
      changePassword() {
        this.modals.modalchangepass = true;
      },
      onSubmit() {
        console.log("TITLE : " + this.title);
        console.log("MESSAGE : " + this.message);
        console.log("TIMESLOT : " + this.timeslot);
        console.log("TIERS : ");
        console.log(this.tiers);
        console.log("DATE : " + this.dates.simple);
            if (this.title !== '' || this.title !== '' && this.message !== '') {
                this.localerrors = null;


                let formData = {'title':this.title,'message':this.message, 'timeslot' : this.timeslot,'tiers' : this.tiers, 'date' : this.dates.simple, 'budget': this.budget};
                console.log(formData);
                Promise.all([
                  store.dispatch(UPDATE_PROFILE, formData),

                ]).then(() => {
                    this.isLoading = false;
                    this.$router.push({ name: "dashboard" })
                });
            }
            else {

              this.localerrors = "Email or Password cannot be empty !"

            }

          // this.$store
          //   .dispatch(LOGIN, { email, password })
          //   .then(() => this.$router.push({ name: "dashboard" }));
        },
      onChange(event) {
          this.timeslot = event.target.value;
          console.log(event);
      },
      onCopy() {
        this.$notify({
          type: 'success',
          title: 'Copied to clipboard'
        })
      }
    }
  };
</script>
<style></style>
